import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
interface BusPickupAllocationIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}
const BusDropOffAllocation: React.FC<BusPickupAllocationIconProps> = ({
  color,
  ...props
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.39095 13.8441C6.11369 14.1518 5.6391 14.1761 5.33138 13.8988C5.02364 13.6216 4.99846 13.147 5.27572 12.8393L6.39095 13.8441ZM5.33822 12.7758C5.61989 12.5204 6.05553 12.5148 6.34408 12.7748C6.6518 13.0521 6.67601 13.5266 6.39876 13.8344L6.39095 13.8441L5.27572 12.8393L5.28451 12.8305L5.33822 12.7758Z"
      fill={color}
    />
    <path
      d="M1.75 15.833V9L1.75391 8.92285C1.79253 8.54488 2.11183 8.25 2.5 8.25H17.5C17.9142 8.25 18.25 8.58579 18.25 9C18.25 9.41421 17.9142 9.75 17.5 9.75H3.25V15.833C3.25 15.8789 3.28713 15.9168 3.33301 15.917H17.083L17.1602 15.9209C17.5383 15.9594 17.833 16.2787 17.833 16.667C17.8328 17.0551 17.5382 17.3746 17.1602 17.4131L17.083 17.417H3.33301C2.45872 17.4168 1.75 16.7074 1.75 15.833Z"
      fill={color}
    />
    <path
      d="M16.75 6.66667V4.99968C16.7498 3.5732 15.5934 2.41684 14.167 2.41667H5.83301C4.40653 2.41684 3.25018 3.5732 3.25 4.99968V6.66667C3.25 7.08088 2.91421 7.41667 2.5 7.41667C2.08579 7.41667 1.75 7.08088 1.75 6.66667V4.99968C1.75018 2.74477 3.5781 0.916844 5.83301 0.916668H14.167C16.4219 0.916844 18.2498 2.74477 18.25 4.99968V6.66667C18.25 7.08088 17.9142 7.41667 17.5 7.41667C17.0858 7.41667 16.75 7.08088 16.75 6.66667Z"
      fill={color}
    />
    <path
      d="M14.1664 5.91667L14.2435 5.92057C14.6216 5.95905 14.9164 6.27839 14.9164 6.66667C14.9164 7.05494 14.6216 7.37429 14.2435 7.41276L14.1664 7.41667H5.83334C5.41913 7.41667 5.08334 7.08088 5.08334 6.66667C5.08334 6.25245 5.41913 5.91667 5.83334 5.91667H14.1664Z"
      fill={color}
    />
    <path
      d="M3.33334 16.6667H6.66668V18.3333C6.66668 18.7936 6.29358 19.1667 5.83334 19.1667H4.16668C3.70644 19.1667 3.33334 18.7936 3.33334 18.3333V16.6667Z"
      fill={color}
    />
    <g clip-path="url(#clip0_667_49302)">
      <path
        d="M14.4156 14.8094C14.4719 14.8094 14.5281 14.7906 14.5656 14.7437L17.3875 11.9219L17.4063 14.1719C17.4063 14.2844 17.5 14.3875 17.6219 14.3781C17.7344 14.3781 17.8281 14.2844 17.8281 14.1625L17.8 11.4062C17.8 11.2937 17.7062 11.2 17.5937 11.2L14.8281 11.1719C14.7156 11.1719 14.6219 11.2656 14.6219 11.3781C14.6219 11.4906 14.7156 11.5938 14.8281 11.5938L17.0969 11.6125L14.2656 14.4437C14.1813 14.5281 14.1813 14.6594 14.2656 14.7437C14.3031 14.7812 14.3594 14.8094 14.4156 14.8094Z"
        fill={color}
      />
      <path
        d="M14.6221 11.3779C14.6222 11.2655 14.7157 11.1719 14.8281 11.1719L17.5938 11.2002L17.6348 11.2041C17.7282 11.2235 17.7998 11.3078 17.7998 11.4063L17.8281 14.1621C17.8281 14.2839 17.7345 14.3778 17.6221 14.3779C17.5156 14.3861 17.4299 14.3087 17.4102 14.2139L17.4063 14.1719L17.3877 11.9219L14.5654 14.7441C14.5372 14.7792 14.4984 14.7983 14.457 14.8057L14.416 14.8096C14.3881 14.8096 14.3596 14.8026 14.334 14.791L14.2656 14.7441C14.1918 14.6703 14.1829 14.5603 14.2383 14.4775L14.2656 14.4434L17.0967 11.6123L14.8281 11.5938C14.7298 11.5938 14.6455 11.5149 14.626 11.4199L14.6221 11.3779ZM14.3223 11.3779C14.3223 11.6381 14.5321 11.8915 14.8262 11.8926L14.8252 11.8936L16.3789 11.9063L14.0537 14.2314C13.8774 14.4077 13.8552 14.6758 13.9873 14.875L14.0537 14.9561C14.1367 15.0389 14.2662 15.1094 14.416 15.1094C14.5275 15.1093 14.6695 15.073 14.7773 14.9561L17.0947 12.6387L17.1064 14.1748C17.108 14.4318 17.3173 14.6862 17.6221 14.6758L17.6221 14.6777C17.6263 14.6777 17.6305 14.6759 17.6348 14.6758C17.638 14.6756 17.6413 14.677 17.6445 14.6768L17.6445 14.6748C17.9201 14.6627 18.1279 14.4335 18.1279 14.1621L18.1279 14.1592L18.0996 11.4033C18.098 11.1274 17.8726 10.903 17.5967 10.9014L14.8311 10.8721L14.8281 10.8721L14.7266 10.8818C14.4965 10.9292 14.3224 11.1346 14.3223 11.3779Z"
        fill={color}
      />
    </g>
    <path
      d="M13.3333 16.6667H16.6667V18.3333C16.6667 18.7936 16.2936 19.1667 15.8333 19.1667H14.1667C13.7064 19.1667 13.3333 18.7936 13.3333 18.3333V16.6667Z"
      fill={color}
    />
    <defs>
      <clipPath id="clip0_667_49302">
        <rect
          width="6"
          height="6"
          fill="white"
          transform="matrix(-1 8.74228e-08 8.74228e-08 1 19 10)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default BusDropOffAllocation;
